module.exports = __webpack_public_path__ + "static/media/leftbs.8098146b.png";